export default "__VITE_ASSET__DtlqF617__"